/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import $ from 'jquery'
import popper from 'popper.js'

window.jQuery = window.$ = window.jquery = $
window.Popper = popper
global.Popper = popper
require('bootstrap/dist/js/bootstrap')
require('@fortawesome/fontawesome-pro/js/all.min')

$(function () {
    let $collapseButton = $('#sidebarCollapse')

    if (Cookies.get('hideSidebar') === 'true') {
        if (jQuery('#sidebar').hasClass('active') === false) {
            toggleTooltips(toggleBar($collapseButton.find('i')))
        } else {
            toggleTooltips(true)
        }
    }

    $collapseButton.on('click', function () {
        let state = toggleBar($(this).find('i'))

        Cookies.set('hideSidebar', state)

        toggleTooltips(state)
    })

    function toggleBar ($icon) {
        $icon.toggleClass('fa-angle-double-left').toggleClass('fa-angle-double-right')

        $('#sidebar').toggleClass('active')

        return jQuery('#sidebar').hasClass('active')
    }

    function toggleTooltips (state) {
        if (state === true) {
            $('#sidebar *[data-toggle="tooltip"]').tooltip()
        } else {
            $('#sidebar *[data-toggle="tooltip"]').tooltip('dispose')
        }
    }
})
